/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeDLSecureBorrowerAutoDebitCancelPaymentPage() {
  customValidationInit(false);
  aspControlValidationInit();

  $(".responsiveTable").DataTable({
    responsive: {
      details: {
        display: $.fn.dataTable.Responsive.display.childRowImmediate,
        type: "",
      },
    },
    scrollX: false,
    paging: false,
    searching: false,
    ordering: false,
    info: false,
  });

  $(".firstColumn").attr("tabindex", -1);
}
